module.exports = __webpack_public_path__ + "static/img/orgchart-heading.10c66da.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/orgchart/orgchart-heading.png
// module id = 2998
// module chunks = 1